export interface AccountingStat {
  label: string;
  value: string;
  valueColor?: string;
  subtext?: string;
  iconBg: string;
  iconColor: string;
  paymentModes?: { label: string; value: string }[];
}

export interface CashInflowSegment {
  label: string;
  sublabel: string;
  amount: string;
  color: string;
  legendColor: string;
  percent: number;
}

export type RiskLevel = 'Block' | 'Watch' | 'Safe';

export interface CustomerDue {
  customer: string;
  area: string;
  outstanding: string;
  overdueDays: string;
  creditLimit: string;
  creditUsedPercent: number;
  lastPayment: string;
  rep: string;
  risk: RiskLevel;
  /** AR aging buckets (VP-ADM-004), pre-formatted for display. */
  aging0_30: string;
  aging31_60: string;
  aging61_90: string;
  aging90Plus: string;
}

export const riskColors: Record<RiskLevel, { bg: string; color: string }> = {
  Block: { bg: '#FEF2F2', color: '#DC2626' },
  Watch: { bg: '#FFFBEB', color: '#D97706' },
  Safe: { bg: '#ECFDF5', color: '#059669' },
};

export type CollectionStatus = 'Deposited' | 'Pending' | 'In Transit';

export interface CollectionItem {
  rep: string;
  initials: string;
  avatarBg: string;
  paymentCount: number;
  amount: string;
  status: CollectionStatus;
}

export const collectionStatusColors: Record<CollectionStatus, { color: string }> = {
  Deposited: { color: '#059669' },
  Pending: { color: '#D97706' },
  'In Transit': { color: '#2563EB' },
};

export type TransactionType = 'Invoice' | 'Payment' | 'Credit Note';

export interface LedgerEntry {
  date: string;
  customer: string;
  type: TransactionType;
  reference: string;
  description: string;
  debit: string;
  credit: string;
  balance: string;
}

export const typeColors: Record<TransactionType, { dot: string; label: string }> = {
  Invoice: { dot: '#2563EB', label: '#2563EB' },
  Payment: { dot: '#059669', label: '#059669' },
  'Credit Note': { dot: '#DC2626', label: '#DC2626' },
};
